import React, { useEffect, useState } from "react";

/**
 * Synthesis-phase loader. By this point the SERP sources have streamed in
 * and the LLM is generating the personalized brief (~20-40s). It sits where
 * the results will render (right after the Research Sources panel), so it
 * doubles as a placeholder for the incoming content.
 *
 * Rotating status messages keep the wait feeling alive — the rep sees real
 * work being narrated rather than a static spinner.
 */

const MESSAGES = [
  "Synthesizing the research into a brief…",
  "Connecting their career history to your pitch…",
  "Surfacing the strongest selling signals…",
  "Writing conversation starters that actually land…",
  "Reading the room — best channel & timing…",
  "Polishing your personalized insights…"
];

const ROTATE_MS = 2600;

const InsightsLoader = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="drInsightsLoader" role="status" aria-live="polite">
      <div className="drInsightsLoader__orb" aria-hidden="true">
        <span className="drInsightsLoader__ring" />
        <i className="material-icons-outlined drInsightsLoader__icon">auto_awesome</i>
      </div>
      <div className="drInsightsLoader__title">Generating personalized insights</div>
      {/* key remount re-triggers the fade/slide-in animation on each rotation */}
      <div className="drInsightsLoader__msg" key={idx}>{MESSAGES[idx]}</div>
      <div className="drInsightsLoader__skeleton" aria-hidden="true">
        <span className="drInsightsLoader__bar" />
        <span className="drInsightsLoader__bar" />
        <span className="drInsightsLoader__bar drInsightsLoader__bar--short" />
      </div>
    </div>
  );
};

export default InsightsLoader;
